import React, { useEffect, useState } from 'react'
import { Button, Checkbox, message, Radio, Typography ,Grid} from "antd";
import "./Appointmenttype.css";
import { ArrowLeftOutlined, ArrowRightOutlined, DownOutlined, UpOutlined,RightOutlined } from "@ant-design/icons";
import { capitalizeWords } from '../Common/CommonFunction';
const { Title, Text } = Typography;

// const options = [
//     { key: "gp", title: "GP appointment", product_category_id: 1, description: "one-liner description", icon: <ArrowRightOutlined /> },
//     { key: "health", title: "Health screens", product_category_id: 2, description: "one-liner description", icon: <DownOutlined /> },
//     { key: "video", title: "Video consultations", product_category_id: 3, description: null, icon: <ArrowRightOutlined /> },
// ];

const Appointmenttype = (props) => {
  const [SelectedAppointmentData, setSelectedAppointmentData] = useState(() => {
    // Use product_category_id from props if provided, otherwise default to 1
    const defaultCategoryId = props.productCategoryId || null;
    const defaultProdcat = (props.options || []).find(opt => opt.product_category_id === Number(defaultCategoryId));
    return defaultProdcat ? { productCategory: defaultProdcat } : null;
  });
    const [messageApi, contextHolder] = message.useMessage();
  let productId =  props.productId ? props.productId  : null;

  // normalize initial selectedClinics to an array of strings so comparisons are consistent
  const initialSelectedClinics = productId ? [String(productId)] : [];
  const [selectedClinics, setSelectedClinics] = useState(initialSelectedClinics);
    const [healthBooking,setHealthBooking]=useState(false)
    const [options, setOptions] = useState(props?.options || []); // Use props.options if available
    
  const { useBreakpoint } = Grid;
    const screens = useBreakpoint();

    const selectAppointmentCategory = () => {
        if (SelectedAppointmentData && SelectedAppointmentData.productCategory && SelectedAppointmentData.productCategory.product_category_id) {
            if (SelectedAppointmentData.productCategory.product_category_id == 2 && !SelectedAppointmentData?.non_gp_product_id) {
                messageApi.error({
                    type: 'error',
                    content: "Selct Appointment sub category First",
                });
                return;
            }
            if (SelectedAppointmentData?.productCategory?.product_category_id && SelectedAppointmentData?.productCategory?.product_category_id == 3) {
                window.open('https://ldc-online-booking.semble.io/?token=2a453adcfcb727cfd1e91f3e245edcd360931ec3', '_blank');
                return
            }
            // console.log('SelectedAppointmentData:::', SelectedAppointmentData?.productCategory?.product_category_id)
            // return
            props.callback(SelectedAppointmentData, 'BookingForm')
        } else {
            if (!SelectedAppointmentData?.productCategory?.product_category_id) {
                messageApi.error({
                    type: 'error',
                    content: "Selct Appointment category First",
                });
            }
        }
    }
    const handleClinicChange = (e, type) => {
        const value = e.target.value;
        const checked = e.target.checked;

        setSelectedClinics(prev => {
            if (checked) {
                if (prev.length >= 1) {
                    messageApi.error({
                        type: 'error',
                        content: 'You can slect only one option.',
                    });
                    return prev; // don't add more
                } else {
                    return [...prev, value.toString()]; // add if under limit
                }
            } else {
                return prev.filter(item => item !== value); // remove
            }
        });
        if (type == 'GP') {
            setSelectedAppointmentData(prev => ({ ...prev, gp_product_id: value }))
        } else if (type == 'HC') {
            setSelectedAppointmentData(prev => ({ ...prev, non_gp_product_id: value }))
        }
    };
    const selectAppointmentCategoryData = (prodcat) => {
        setSelectedClinics([])
        setSelectedAppointmentData({ productCategory: prodcat })
    }
    if(props.ContinueButoonStylingMiddle){
        // healthBooking?setHealthBooking(false):console.log("already false")
    }else{
    }

    const priorityOrder = [  "Vital", "Bronze","Silver", "Gold","Platinum","Diamond"];
      const sortedProducts = props?.getAllHealthScreenData?.getAllHealthScreenData?.data?.filter(product => {
          const name = product?.name.toLowerCase();
          return name
        })
        // .sort((a, b) => {
        //   const getPriority = (name) =>
        //     priorityOrder.findIndex(p => name?.toLowerCase().includes(p.toLowerCase()));
        //   return getPriority(a?.name) - getPriority(b?.name);
        // });
    return (
        <div className='apptSection' style={{ maxWidth: "605px", margin: "auto", textAlign: "center" }}>
            {contextHolder}
            <div style={{ background: "#00838540", padding: 10, marginBottom: 20, marginTop:screens.md?"50px":"0px" }}>
                <Title level={4} style={{ margin: 0 ,color :'#008385',
                  // fontFamily:"Lato !important",
                  fontWeight:"400",size:"20px",lineHeight:"100%",letterSpacing: '0.3px' }} className='textalign'>
                  {/* {capitalizeWords('Appointment type')}: */} Appointment type
                  </Title>
            </div>
            {options && options.length && options.map((prodcat, i) => {
                // Determine dynamic classes
                const isSelected = prodcat.product_category_id === SelectedAppointmentData?.productCategory?.product_category_id;
                const isHealth = isSelected && SelectedAppointmentData?.productCategory?.product_category_id === 2;
                const hasDescription = !!prodcat?.description;
                let divClass = "apptTypeBox";
                if (prodcat.key === "video") divClass += " aptType";
                if (isSelected) divClass += " selected";
                if (isHealth) divClass += " health";
                if (hasDescription) divClass += " hasDescription";
                return (
                  <div className={divClass}>
                    {/* <hr style={{ marginTop: 30, marginBottom:"0", border: prodcat && prodcat.product_category_id && prodcat.product_category_id == SelectedAppointmentData?.productCategory?.product_category_id ? '1px solid #008385' : '' }} /> */}
                    <div style={{ display: "flex", justifyContent: "start", alignItems: "center",  textAlign: 'center',position:"relative",paddingLeft:screens?.md ? "20%" : "4%"  }} onClick={() => selectAppointmentCategoryData(prodcat)}>

                        <div style={{ display: screens.md ? "block": "none"}}>
                          {((i + 1) % 2 === 0) &&
                        //  ((selectedClinics=== hcData.non_gp_product_id.toString()) ?
                        (prodcat.product_category_id == SelectedAppointmentData?.productCategory?.product_category_id && SelectedAppointmentData?.productCategory?.product_category_id == 2?
                          <RightOutlined style={{ position:"absolute",left:"10%", color:"#008385" }} /> :
                         <DownOutlined style={{position:"absolute",left:"10%", color:"#008385" }} />
                         )}
                        </div>
                        <div style={{ marginRight: ((i + 1) % 2 === 0) ? '0%' : '0',cursor: 'pointer' ,textAlign:"left",width : "70%",minHeight:"50px",display:prodcat?.description?"block":"flex",alignItems:"center"}}>
                            {prodcat.title && <Title level={5} style={{ margin: 0 ,color:"rgba(74, 74, 74, 1)",
                              // fontFamily:"Lato !important",
                              fontWeight:"500",size:"20px",lineHeight:"100%",letterSpacing: '0.3px',paddingBottom:prodcat?.description ?"7px":"0px" }}>{prodcat.title}</Title>}
                            {prodcat.description && <Text type="secondary" style={{ maxWidth:"70%"}}> {prodcat.description}</Text>}

                        </div>

                        {/* {((i + 1) % 2 !== 0) && <ArrowRightOutlined style={{position:"absolute",right:"15%" , color:"#008385"}} />} */}
                        <div style={{ display: screens.md ? "none": "block"}}>
                          {((i + 1) % 2 === 0) &&
                        //  ((selectedClinics=== hcData.non_gp_product_id.toString()) ?
                        (prodcat.product_category_id == SelectedAppointmentData?.productCategory?.product_category_id && SelectedAppointmentData?.productCategory?.product_category_id == 2?
                          <RightOutlined style={{ position:"absolute",right:"15%", color:"#008385" }} /> :
                         <DownOutlined style={{position:"absolute",right:"15%",  color:"#008385" }} />
                         )}
                        </div>

                    </div>
                  <Radio.Group
                  value={Array.isArray(selectedClinics) ? selectedClinics[0] : selectedClinics}
                  style={{backgroundColor:"rgb(240 250 250)",width:"100%",maxWidth:"605px" ,display:SelectedAppointmentData?.productCategory?.product_category_id == 2 ? "block" : "none"}}
                    onChange={(e) => {
                      setSelectedClinics([e.target.value])
                      setSelectedAppointmentData(prev => ({ ...prev, non_gp_product_id: e.target.value }))
                    }}
                    >
                        {prodcat.product_category_id == SelectedAppointmentData?.productCategory?.product_category_id && SelectedAppointmentData?.productCategory?.product_category_id == 2 ? sortedProducts.map(hcData => {
                           
                           if (hcData.status == 1) {
                                return <div style={{ marginTop: 15 }}>
                                    <div style={{ display: "flex",alignItems:"flex-start",paddingLeft:screens.md ? "22%" : "3%"}}>

                                        {/* <Checkbox value={hcData.non_gp_product_id.toString()} checked={selectedClinics.includes(hcData.non_gp_product_id.toString())} className="round-checkbox" onClick={(e) => handleClinicChange(e, 'HC')} /> */}


                                        {/* here need to change */}
                                        <div style={{ display: 'flex', alignItems: 'start', marginRight: 10, cursor: 'pointer'}}>
                                        <Radio 
                                        value={hcData.non_gp_product_id.toString()} 
                                        checked={(
                                          Array.isArray(selectedClinics)
                                            ? selectedClinics.includes(hcData.non_gp_product_id.toString())
                                            : String(selectedClinics) === hcData.non_gp_product_id.toString()
                                        ) || String(productId) === hcData.non_gp_product_id.toString() }
                                        className="round-checkbox" >
                                        </Radio>
                                            </div>
                                            <div style={{width:"400px",fontSize:"15px"}}>
                                               <div style={{textAlign:"left",
                                                // fontFamily:"Lato", 
                                                fontSize:"16px ",fontWeight:"400",color:"#4A4A4A"}}>{hcData.name}</div>
                                               {/* <div style={{marginTop:1,fontFamily:"Lato", fontSize:"14px ",fontWeight:"400",color:"#4A4A4A",textAlign:"left" }}>{hcData.product_specific_booking_page_short_copy}</div> */}
                                               {/* <div
                                                style={{
                                                  margin: 1,
                                                  fontFamily: "Lato",
                                                  fontSize: "14px",
                                                  fontWeight: "400",
                                                  color: "#4A4A4A",
                                                  textAlign: "left"
                                                }}
                                                className="html-content"
                                                dangerouslySetInnerHTML={{ __html: hcData.product_specific_booking_page_short_copy  }}
                                              /> */}

                                                <div
                                                  className="mobile-copy html-content"
                                                  dangerouslySetInnerHTML={{ __html: hcData.product_specific_booking_page_short_copy }}
                                                />
                                                <div
                                                  className="desktop-copy html-content"
                                                  dangerouslySetInnerHTML={{ __html: hcData.product_specific_booking_page_long_copy }}
                                                />


                                               {healthBooking?"": setHealthBooking(true)}
                                               {/* {console.log(selectedClinics)} */}
                                               {/* {console.log(hcData.non_gp_product_id.toString())} */}
                                               
                                               
                    {(Array.isArray(selectedClinics) ? selectedClinics.includes(hcData.non_gp_product_id.toString()) : String(selectedClinics) === hcData.non_gp_product_id.toString()) || String(productId) === hcData.non_gp_product_id.toString() && (
  <div>
    {/* General Checks */}
    { hcData?.checks && hcData?.checks?.general?.length > 0 && (
      <div>
        <ul style={{ margin: "0px" }}>
          {hcData.checks.general.map((item, index) => (
            <li
              key={index}
              style={{
                // fontFamily: "Lato",
                color: "#4A4A4A",
                fontWeight: "500",
                fontSize: "12px",
                textAlign: "left"
              }}
            >
              {item}
            </li>
          ))}
        </ul>
      </div>
    )}

    {/* Male-specific Checks */}
    {hcData?.checks?.male_specific?.length > 0 && (
      <div>
        <div
          style={{
            // fontFamily: "Lato",
            color: "#4A4A4A",
            fontWeight: "600",
            fontSize: "12px",
            textAlign: "left",
            margin: "10px 0px"
          }}
        >
          Male-specific Checks:
        </div>
        <ul>
          {hcData.checks.male_specific.map((item, index) => (
            <li
              key={index}
              style={{
                // fontFamily: "Lato",
                color: "#4A4A4A",
                fontWeight: "500",
                fontSize: "12px",
                textAlign: "left"
              }}
            >
              {item}
            </li>
          ))}
        </ul>
      </div>
    )}

    {/* Female-specific Checks */}
    {hcData?.checks?.female_specific?.length > 0 && (
      <div>
        <div
          style={{
            // fontFamily: "Lato",
            color: "#4A4A4A",
            fontWeight: "600",
            fontSize: "12px",
            textAlign: "left",
            margin: "10px 0px"
          }}
        >
          Female-specific Checks:
        </div>
        <ul>
          {hcData.checks.female_specific.map((item, index) => (
            <li
              key={index}
              style={{
                // fontFamily: "Lato",
                color: "#4A4A4A",
                fontWeight: "500",
                fontSize: "12px",
                textAlign: "left"
              }}
            >
              {item}
            </li>
          ))}
        </ul>
      </div>
    )}
  </div>
)}

                                            

                                            </div>
                                        <br />

                                    </div>
                                    {/* <div style={{ marginLeft: '30%', textWrap: 'inherit', textAlign: 'left' }} dangerouslySetInnerHTML={{ __html: hcData.product_specific_booking_page_short_copy }} /> */}
                                </div>

                            }
                        }) : ''
                        }
                    </Radio.Group>
                    {/* <hr style={{ marginTop: prodcat.description ? 10 : 10, border: prodcat && prodcat.product_category_id && prodcat.product_category_id == SelectedAppointmentData?.productCategory?.product_category_id ? '1px solid #008385' : '' }} /> */}
                </div>)
            })}
            <div
            style={{
                display: 'flex',
                justifyContent: props.ContinueButoonStylingMiddle ? 'center' : ""||"center",
                position:"relative"
            }}
            >
            {!props.ContinueButoonStylingMiddle && (
                <Button
                shape="square"
                icon={<ArrowLeftOutlined style={{ color: '#008385', fontSize: '18px' }} />}
                style={{
                    backgroundColor: '#C8E6E6',
                    border: 'none',
                    width: '40px',
                    height: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginTop: 20,
                    marginRight: 10,
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                    position:"absolute",
                    left:"0px"
                }}
                onClick={() => props.callBackForbackpage(null)}
                />
            )}

            <Button
                type="primary"
                size="large"
                style={{
                marginTop: 20,
                background: '#008385',
                borderColor: '#008385',
                width:"182px",
                borderRadius:"10px"
                }}
                onClick={selectAppointmentCategory}
            >
                Continue
            </Button>
            </div>
            <style jsx>
                {`
                
                  .html-content p,
                  .html-content h1,
                  .html-content h2,
                  .html-content ul,
                  .html-content b,
                  .html-content strong ,
                  .html-content li 
                  {
                      font-weight: 400 !important;
                      margin: 0 !important;
                      padding: 0;
                    }

                  .html-content  em {
                      font-style: normal; /* overrides browser italic */
                      color: inherit;     /* optional: match parent text color */
                    }
                `}
            </style>
        </div>
    )
}

export default Appointmenttype